import React, { useState, useMemo, useCallback, ReactNode } from 'react';
import { LocationContext } from './useLocationContext';

export interface Location {
  id: string;
  name: string;
  address?: string;
  city?: string;
  state?: string;
  phone?: string;
  websiteUrl?: string;
  isPrimary: boolean;
}

export function LocationProvider({ children }: { children: ReactNode }) {
  const [currentLocation, setCurrentLocation] = useState<Location | null>(null);
  const [locations, setLocations] = useState<Location[]>([]);

  const handleSetCurrentLocation = useCallback((location: Location) => {
    setCurrentLocation(location);
  }, []);

  const handleSetLocations = useCallback((locs: Location[]) => {
    setLocations(locs);
  }, []);

  const value = useMemo(
    () => ({
      currentLocation,
      locations,
      setCurrentLocation: handleSetCurrentLocation,
      setLocations: handleSetLocations,
    }),
    [currentLocation, locations, handleSetCurrentLocation, handleSetLocations],
  );

  return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>;
}
